import { Flex } from 'antd';
import Icon from './Icon';

export default function Spinner({ style }) {
  return ( 
    <Flex style={{ width: '100%', padding: '60px' }} justify={"center"}>
      <Icon
        name="spinner"
        size="72px"
        spin={true}
      > 
      </Icon>
    </Flex>
  )
}